import { baseApiClient as api } from "../baseService";
export const addTagTypes = ["investigation_records_requests"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      investigationRecordsRequestsList: build.query<
        InvestigationRecordsRequestsListApiResponse,
        InvestigationRecordsRequestsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/investigation-records-requests/`,
        }),
        providesTags: ["investigation_records_requests"],
      }),
      investigationRecordsRequestsCreate: build.mutation<
        InvestigationRecordsRequestsCreateApiResponse,
        InvestigationRecordsRequestsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/investigation-records-requests/`,
          method: "POST",
          body: queryArg.createInvestigationRecordsRequest,
        }),
        invalidatesTags: ["investigation_records_requests"],
      }),
      investigationRecordsRequestsRetrieve: build.query<
        InvestigationRecordsRequestsRetrieveApiResponse,
        InvestigationRecordsRequestsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/investigation-records-requests/${queryArg.id}/`,
        }),
        providesTags: ["investigation_records_requests"],
      }),
      investigationRecordsRequestsUpdate: build.mutation<
        InvestigationRecordsRequestsUpdateApiResponse,
        InvestigationRecordsRequestsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/investigation-records-requests/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.updateInvestigationRecordsRequest,
        }),
        invalidatesTags: ["investigation_records_requests"],
      }),
      investigationRecordsRequestsPartialUpdate: build.mutation<
        InvestigationRecordsRequestsPartialUpdateApiResponse,
        InvestigationRecordsRequestsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/investigation-records-requests/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedUpdateInvestigationRecordsRequest,
        }),
        invalidatesTags: ["investigation_records_requests"],
      }),
      investigationRecordsRequestsDestroy: build.mutation<
        InvestigationRecordsRequestsDestroyApiResponse,
        InvestigationRecordsRequestsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/investigation-records-requests/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["investigation_records_requests"],
      }),
      investigationRecordsRequestsGenerateFoiaLetter: build.query<
        InvestigationRecordsRequestsGenerateFoiaLetterApiResponse,
        InvestigationRecordsRequestsGenerateFoiaLetterApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/investigation-records-requests/generate-foia-letter/`,
          params: {
            format: queryArg.format,
            police_report_id: queryArg.policeReportId,
            template_id: queryArg.templateId,
          },
        }),
        providesTags: ["investigation_records_requests"],
      }),
      investigationRecordsRequestsSendCheque: build.mutation<
        InvestigationRecordsRequestsSendChequeApiResponse,
        InvestigationRecordsRequestsSendChequeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/investigation-records-requests/send-cheque/`,
          method: "POST",
          body: queryArg.sendChequeRequest,
        }),
        invalidatesTags: ["investigation_records_requests"],
      }),
      investigationRecordsRequestsSendFoiaLetter: build.mutation<
        InvestigationRecordsRequestsSendFoiaLetterApiResponse,
        InvestigationRecordsRequestsSendFoiaLetterApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/investigation-records-requests/send-foia-letter/`,
          method: "POST",
          body: queryArg.sendFoiaLetterRequest,
        }),
        invalidatesTags: ["investigation_records_requests"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type InvestigationRecordsRequestsListApiResponse =
  /** status 200  */ ReadInvestigationRecordsRequest[];
export type InvestigationRecordsRequestsListApiArg = {
  matterId: string;
};
export type InvestigationRecordsRequestsCreateApiResponse =
  /** status 201  */ ReadInvestigationRecordsRequest;
export type InvestigationRecordsRequestsCreateApiArg = {
  matterId: string;
  createInvestigationRecordsRequest: CreateInvestigationRecordsRequest;
};
export type InvestigationRecordsRequestsRetrieveApiResponse =
  /** status 200  */ ReadInvestigationRecordsRequest;
export type InvestigationRecordsRequestsRetrieveApiArg = {
  id: string;
  matterId: string;
};
export type InvestigationRecordsRequestsUpdateApiResponse =
  /** status 200  */ ReadInvestigationRecordsRequest;
export type InvestigationRecordsRequestsUpdateApiArg = {
  id: string;
  matterId: string;
  updateInvestigationRecordsRequest: UpdateInvestigationRecordsRequest;
};
export type InvestigationRecordsRequestsPartialUpdateApiResponse =
  /** status 200  */ ReadInvestigationRecordsRequest;
export type InvestigationRecordsRequestsPartialUpdateApiArg = {
  id: string;
  matterId: string;
  patchedUpdateInvestigationRecordsRequest: UpdateInvestigationRecordsRequest2;
};
export type InvestigationRecordsRequestsDestroyApiResponse = unknown;
export type InvestigationRecordsRequestsDestroyApiArg = {
  id: string;
  matterId: string;
};
export type InvestigationRecordsRequestsGenerateFoiaLetterApiResponse =
  /** status 200  */ Blob;
export type InvestigationRecordsRequestsGenerateFoiaLetterApiArg = {
  /** Output format - 'docx' or 'pdf' (default: 'docx') */
  format?: string;
  matterId: string;
  /** ID of the police report */
  policeReportId: string;
  /** Optional specific template ID to use */
  templateId?: string;
};
export type InvestigationRecordsRequestsSendChequeApiResponse =
  /** status 201  */ SendMailResponse;
export type InvestigationRecordsRequestsSendChequeApiArg = {
  matterId: string;
  sendChequeRequest: SendChequeRequest;
};
export type InvestigationRecordsRequestsSendFoiaLetterApiResponse =
  /** status 201  */ SendMailResponse;
export type InvestigationRecordsRequestsSendFoiaLetterApiArg = {
  matterId: string;
  sendFoiaLetterRequest: SendFoiaLetterRequest;
};
export type InvestigationRequestType =
  | "foia"
  | "crash_report"
  | "incident_report";
export type ContactHandleType =
  | "PHONE"
  | "EMAIL"
  | "WEBSITE"
  | "FAX"
  | "OTHER"
  | "MAILING_ADDRESS";
export type WebSource = {
  /** The URL of the source */
  url: string;
  /** Very short display text for the source URL */
  title: string;
};
export type ContactHandleSchema = {
  id?: (string | string) | null;
  /** The captured contact information. Should contain an E.164 formatted phone number, or an email address, or a website, or a fax number. */
  value?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  handle_type: ContactHandleType;
  /** Short description of the handle; e.g. 'Billing Dept Toll-Free', 'Front Desk Fax' etc. */
  name?: string | null;
  /** Optional notes about the handle. */
  notes?: string | null;
  /** Citations for the handle. */
  sources?: WebSource[] | null;
  /** Whether this is the preferred contact handle. */
  preferred?: boolean | null;
  division_id?: (string | string) | null;
};
export type JurisdictionType =
  | "city"
  | "county"
  | "state"
  | "federal"
  | "tribal"
  | "special";
export type PoliceDepartmentEnrichmentStatus =
  | "not_enriched"
  | "enrichment_in_progress"
  | "enrichment_failed"
  | "enrichment_succeeded";
export type ServiceType =
  | "crash_reports"
  | "foia_equivalent"
  | "criminal_records"
  | "incident_reports"
  | "general_records";
export type PoliceRecordsInquiryMajorVendor =
  | "carfax_crashdocs"
  | "lexis_nexis_buycrash"
  | "independent_portal"
  | "next_request"
  | "gov_qa"
  | "not_a_portal"
  | "txdot_cris";
export type AddressSchema = {
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  province_or_state?: string | null;
  postal_or_zip?: string | null;
  country_code?: string | null;
};
export type MailRequirement =
  | "CLIENT_PHOTO_ID_COPY"
  | "FIRM_LETTERHEAD"
  | "PROOF_OF_REPRESENTATION"
  | "COMPLETED_REQUEST_FORM"
  | "NOTARIZED_REQUEST_FORM";
export type FeeComponent = {
  /** The amount of the fee in cents. */
  amount_cents: number;
  /** One line description of the component of the total fee backed by research and assumptions.
    ex:
    - "Upper bound estimate of 20 pages at $0.25/page as specified by ____"
    - "Estimating up to 30min of labor at stated rate of $20/hour as specified by ____"
    - "Base certified crash report fee $8.44 as specified by ____"
    - "Added 7% for tax because site mentions it's not included in provided info" */
  description: string;
};
export type RecordsFeeEstimate = {
  /** An estimated fee for requesting a copy of a police report.
    Depending on the department, sometimes this is called a "crash report", "accident report",
    "incident report", or "police report".
    
    Rule: IF more than one report option is available, bias to the more expensive, or certified option.
    If fees are not defined for the department, fall back to county or state guidance on fees. */
  estimated_fee_cents?: number | null;
  /** All the components that led to the estimated fee */
  components?: FeeComponent[] | null;
  /** Full verbatim fee details including:
    - Exact language from official source
    - Conditions, alternatives, or special cases
    - Statutory citations (e.g., "per RSMo §610.026")
    - Payment instructions
    ALWAYS populate this when ANY fee information is available. */
  notes?: string | null;
  /** A 0-1 score indicating the confidence. */
  confidence_score?: number | null;
  /** 2-3 sentences explaining the confidence score. */
  reasoning?: string | null;
};
export type CheckMailingInstructions = {
  /** Verifiable instructions on how to request a police report from the agency by mail. */
  instructions?: string;
  /** The mailing address to send the request to. */
  address: AddressSchema;
  /** The best, single name of the entity to make the check payable to. (Payee)
    Do not place anything except for a single, bank-ready name here. */
  payable_to?: string | null;
  /** Any specific text required to be written on the check memo line, if explicitly mentioned, otherwise null.
    Example: "Police Report Request" or "Report #[REPORT_NUMBER]" or "Accident Report Fee"
    available variables: "[REPORT_NUMBER], [CLIENT_NAME], [DATE_OF_LOSS]" */
  memo_instructions?: string | null;
  /** The number of days after incident date to wait before requesting
    the records by mail, if explicitly specified, otherwise null. */
  wait_before_requesting_days?: number | null;
  /** Any department-specified, or state-specified, number of days to expect for processing, if explicitly stated, otherwise null. */
  estimated_processing_days?: number | null;
  /** Any items that are explicitly REQUIRED for requesting a police report by mail, if described, otherwise null. */
  required_items?: MailRequirement[] | null;
  /** Any special requirements for requesting a police report by mail, if described, otherwise null. */
  special_requirements?: string | null;
  /** The estimated set of fees to request a copy of a police report by mail.
    
    - (for any question of the report type being sought): assume we want the most detailed version of the report, sometimes this is "crash report", "accident report", "incident report", "police report", bias to the more expensive of the four
    - (for any page-based fee structure) assume a 20 page incident report
    - (for any requestor-based fee differences) assume legal representative of involved party
    - (for request-method based pricing) assume check + mail but bias to more expensive option
    - (for any charge for a missing report number) assume we do not have the report number
    - (for any charges related to labor) assume 30 minutes of labor
    - (for any charges related to certified copies) assume we are paying for the most certified copy */
  fee_structure?: RecordsFeeEstimate;
  /** Web pages that were used to gather the information. */
  citations?: WebSource[] | null;
};
export type DepartmentForm = {
  /** Concise title for the Form */
  title: string;
  /** Concise sentence description of the Form and its purpose. */
  description?: string | null;
  /** URL of the Form file */
  file_url: string;
};
export type ReadDepartmentRecordsChannel = {
  /** A concise title for the channel - e.g. "FOIA Portal", "Records Department Phone" */
  title?: string | null;
  /** Single sentence description of the channel and its purpose. */
  description?: string | null;
  /** Tags for record types that can be serviced by this channel.
    e.g. ["crash_reports", "foia_equivalent", "general_records"] */
  services_provided?: ServiceType[] | null;
  /** The type of channel: mail, phone, email, online_portal, fax */
  channel_type?: string | null;
  /** Web sources/citations for this channel information */
  citations?: WebSource[] | null;
  /** Concise instructions on how to request records from the police department, if explicitly mentioned, otherwise null.
    e.g. 'To request a police report, please visit the police department website and fill out the request form.' */
  instructions: string;
  handle: ContactHandleSchema;
  fee_amount?: number | null;
  major_vendor?: PoliceRecordsInquiryMajorVendor;
  /** An explicitly provided link to a pdf, docx, or other static file form that the department publishes and requires
    inquirers to fill out for making police report requests. Not every PD may ask for inquirers to provide a formal request,
    but if they do, we should capture them here - otherwise null. */
  required_document_url?: WebSource;
  mailing_instructions?: CheckMailingInstructions;
  /** Department-provided forms associated with this channel */
  forms?: DepartmentForm[] | null;
  /** Portal URL if this is an online portal channel */
  portal_url?: string | null;
  /** Portal domain if this is an online portal channel */
  portal_domain?: string | null;
  id: string | string;
  created_at: string;
  modified_at: string;
  police_department_id: string | string;
  required_document_file_url?: string | null;
};
export type TimeZone = "PST" | "MST" | "CST" | "EST" | "AKST" | "AST" | "HST";
export type ReadPoliceDepartment = {
  /** Police department name, if explicitly mentioned, otherwise null */
  name?: string | null;
  /** Police department state, if explicitly mentioned, otherwise null. e.g. 'California' */
  state_name?: string | null;
  /** Police department state code, if explicitly mentioned, otherwise null. e.g. 'CA' */
  state_code?: string | null;
  /** The best available contact methods for the police department for requesting records, documents or reports.
    - NON-EMERGENCY phone lines
    - Any specific 'records' department phone or fax numbers
    - Mailing addresses for records requests
    - Email addresses for records requests
    - Online portals for records requests
    - Department homepage */
  handles?: ContactHandleSchema[] | null;
  /** Primary source provided aliases or abbreviations for the department, e.g. 'SFPD' */
  aliases?: string[] | null;
  /** Ascertained jurisdiction type of the police department / agency, if explicitly
    stated. */
  jurisdiction_type?: JurisdictionType;
  /** Primary source provided name or description of the jurisdiction,
    e.g. 'San Francisco', 'Coffee County, Tennessee', 'Major Highways of Tennessee' */
  jurisdiction_name?: string | null;
  /** system use: Whether the police department has been enriched with additional information */
  enrichment_status?: PoliceDepartmentEnrichmentStatus;
  /** A concise, but comprehensive description of the police department, if explicitly mentioned, otherwise null.
    e.g. 'The San Francisco Police Department is the primary law enforcement agency for the City and County of San Francisco.' */
  description?: string | null;
  records_channels?: ReadDepartmentRecordsChannel[];
  /** The time zone of the police department, if explicitly mentioned, otherwise null.
    e.g. 'America/Los_Angeles' */
  time_zone?: TimeZone;
  /** Flag to mark department as do not call - prevents voice agent outreach */
  do_not_call?: boolean;
  id: string | string;
  created_at: string;
  modified_at: string;
};
export type PostGridLetterSize = "us_letter" | "us_legal" | "a4";
export type PostGridAddressPlacement =
  | "top_first_page"
  | "top_of_page"
  | "insert_blank_page";
export type PostGridMailingClass =
  | "first_class"
  | "standard_class"
  | "express"
  | "certified"
  | "certified_return_receipt"
  | "registered"
  | "usps_first_class"
  | "usps_standard_class"
  | "usps_eddm"
  | "usps_express_2_day"
  | "usps_express_3_day"
  | "usps_first_class_certified"
  | "usps_first_class_certified_return_receipt"
  | "usps_first_class_registered"
  | "usps_express_3_day_signature_confirmation"
  | "usps_express_3_day_certified"
  | "usps_express_3_day_certified_return_receipt"
  | "ca_post_lettermail"
  | "ca_post_personalized"
  | "ca_post_neighbourhood_mail"
  | "ca_post_registered"
  | "ca_post_expedited_with_signature"
  | "ca_post_expedited"
  | "ca_post_xpresspost_with_signature"
  | "ca_post_xpresspost"
  | "royal_mail_first_class"
  | "royal_mail_standard_class"
  | "au_post_regular"
  | "au_post_second_class"
  | "ups_express_overnight"
  | "ups_express_2_day"
  | "ups_express_3_day"
  | "ups_express_3_day_signature_confirmation"
  | "ups_express_3_day_adult_signature_confirmation";
export type PostGridObjectStatus =
  | "creating"
  | "ready"
  | "printing"
  | "in_transit"
  | "in_local_area"
  | "processed_for_delivery"
  | "processed"
  | "delivered"
  | "re-routed"
  | "returned_to_sender"
  | "cancelled"
  | "completed"
  | "failed";
export type CarrierTrackingLocation = {
  city?: string | null;
  provinceOrState?: string | null;
  countryCode?: string | null;
  postalOrZip?: string | null;
};
export type CarrierTrackingUpdate = {
  message: string;
  status: string;
  createdAt: string;
  source: string;
  trackingLocation?: CarrierTrackingLocation;
};
export type CarrierTrackingData = {
  status: string;
  statusDetail?: string | null;
  estDeliveryDate?: string | null;
  signedBy?: string | null;
  carrier: string;
  trackingUpdates?: CarrierTrackingUpdate[];
};
export type ReadPostgridLetter = {
  subject?: string | null;
  content?: string | null;
  letter_size?: PostGridLetterSize;
  address_placement?: PostGridAddressPlacement;
  mailing_class?: PostGridMailingClass;
  color?: boolean;
  double_sided?: boolean;
  to_contact_id: string | string;
  from_contact_id?: (string | string) | null;
  return_envelope_id?: (string | string) | null;
  use_return_envelope?: boolean;
  live?: boolean;
  final_pdf_url?: string | null;
  matter_id: string | string;
  id: string | string;
  postgrid_id: string;
  status?: PostGridObjectStatus;
  created_at?: string | null;
  modified_at?: string | null;
  is_test?: boolean;
  tracking_number?: string | null;
  carrier_tracking?: CarrierTrackingData;
  imb_status?: string | null;
  imb_date?: string | null;
  imb_zip_code?: string | null;
  expected_delivery_date?: string | null;
  date_sent?: string | null;
  date_delivered?: string | null;
};
export type PostGridChequeType = "standard" | "voucher";
export type PostGridChequeSize = "us_letter" | "us_legal";
export type ReadPostgridCheque = {
  /** Cheque amount (min $0.01, max enforced by domain) */
  amount: string;
  memo?: string | null;
  number?: number | null;
  date_cleared?: string | null;
  cheque_type?: PostGridChequeType;
  cheque_size?: PostGridChequeSize;
  mailing_class?: PostGridMailingClass;
  to_contact_id: string | string;
  from_contact_id?: (string | string) | null;
  return_envelope_id?: (string | string) | null;
  use_return_envelope?: boolean;
  bank_account_id: (string | string) | null;
  live?: boolean;
  final_pdf_url?: string | null;
  id: string | string;
  matter_id: string | string;
  postgrid_id: string;
  status?: PostGridObjectStatus;
  created_at?: string | null;
  modified_at?: string | null;
  is_test?: boolean;
  tracking_number?: string | null;
  carrier_tracking?: CarrierTrackingData;
  imb_status?: string | null;
  imb_date?: string | null;
  imb_zip_code?: string | null;
  expected_delivery_date?: string | null;
  date_sent?: string | null;
  date_delivered?: string | null;
};
export type ReadInvestigationRecordsRequest = {
  /** Type of records request */
  request_type: InvestigationRequestType;
  /** Internal notes about this request */
  notes?: string | null;
  id: string | string;
  investigation_id: string | string;
  police_department_id: (string | string) | null;
  postgrid_letter_id: (string | string) | null;
  postgrid_cheque_id: (string | string) | null;
  records_channel_id: (string | string) | null;
  created_at: string;
  modified_at: string;
  police_department?: ReadPoliceDepartment;
  postgrid_letter?: ReadPostgridLetter;
  postgrid_cheque?: ReadPostgridCheque;
  records_channel?: ReadDepartmentRecordsChannel;
};
export type CreateInvestigationRecordsRequest = {
  /** Type of records request */
  request_type: InvestigationRequestType;
  /** Internal notes about this request */
  notes?: string | null;
  /** ID of the investigation this request belongs to */
  investigation_id: string | string;
  /** ID of the police department this request was sent to */
  police_department_id: string | string;
  /** Optional ID of the associated PostGrid letter */
  postgrid_letter_id?: (string | string) | null;
  /** Optional ID of the associated PostGrid cheque */
  postgrid_cheque_id?: (string | string) | null;
  /** Optional ID of the police department records channel */
  records_channel_id?: (string | string) | null;
};
export type UpdateInvestigationRecordsRequest = {
  request_type?: InvestigationRequestType;
  /** Internal notes about this request */
  notes?: string | null;
  id: string | string;
  investigation_id?: (string | string) | null;
  police_department_id?: (string | string) | null;
  postgrid_letter_id?: (string | string) | null;
  postgrid_cheque_id?: (string | string) | null;
  records_channel_id?: (string | string) | null;
};
export type UpdateInvestigationRecordsRequest2 = {
  request_type?: InvestigationRequestType;
  /** Internal notes about this request */
  notes?: string | null;
  id: string | string;
  investigation_id?: (string | string) | null;
  police_department_id?: (string | string) | null;
  postgrid_letter_id?: (string | string) | null;
  postgrid_cheque_id?: (string | string) | null;
  records_channel_id?: (string | string) | null;
};
export type SendMailResponse = {
  /** Created investigation request ID */
  investigation_request_id: string | string;
  /** Temporal workflow ID */
  workflow_id: string;
  /** Letter ID if applicable */
  postgrid_letter_id?: (string | string) | null;
  /** Cheque ID if applicable */
  postgrid_cheque_id?: (string | string) | null;
};
export type SendChequeRequest = {
  /** ID of the police report */
  police_report_id: string | string;
  /** ID of the records channel to use */
  channel_id: string | string;
};
export type SendFoiaLetterRequest = {
  /** ID of the police report */
  police_report_id: string | string;
  /** ID of the records channel to use */
  channel_id: string | string;
  /** Optional template ID for letter generation */
  template_id?: (string | string) | null;
  /** Optional field overrides for template */
  overrides?: {
    [key: string]: string;
  };
};
export const {
  useInvestigationRecordsRequestsListQuery,
  useInvestigationRecordsRequestsCreateMutation,
  useInvestigationRecordsRequestsRetrieveQuery,
  useInvestigationRecordsRequestsUpdateMutation,
  useInvestigationRecordsRequestsPartialUpdateMutation,
  useInvestigationRecordsRequestsDestroyMutation,
  useInvestigationRecordsRequestsGenerateFoiaLetterQuery,
  useInvestigationRecordsRequestsSendChequeMutation,
  useInvestigationRecordsRequestsSendFoiaLetterMutation,
} = injectedRtkApi;
